import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const createDashboardSchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' })
    .trim()
    .min(1, { message: 'Campo obrigatório' }),
});

export type CreateDashboardValidationSchema = z.infer<typeof createDashboardSchema>;

export const updateDashboardSchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' })
    .trim()
    .min(1, { message: 'Campo obrigatório' }),
  desired_filters: z.array(z.string()).optional().default([]),
});

export type UpdateDashboardValidationSchema = z.infer<typeof updateDashboardSchema>;

export const updateDashboardVisibilitySchema = z.object({
  visibility: optionSchema,
});

export type UpdateDashboardVisibilityValidationSchema = z.infer<typeof updateDashboardVisibilitySchema>;
